import React, { useState } from 'react'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import IconButton from '@mui/material/IconButton'
import { FaMinimize, FaMaximize } from 'react-icons/fa6'
import defaultTexts from '../../../texts/texts'
import ConfigBillingPaymentMethodsItem from './ConfigBillingPaymentMethodsItem'

const ConfigBillingPaymentMethods = (props) => {
  const { availablePaymentMethods, paymentMethods, setPaymentMethods, paymentMethodIds, setPaymentMethodIds } = props
  const theme = useTheme()

  const [expanded, setExpanded] = useState(true)

  const wrapperStyle = {
    background: 'white',
    borderRadius: '50px 20px 20px 20px',
    boxShadow: '2px 2px 2px rgba(0, 0, 0, 0.25)',
    marginBottom: '40px',
  }

  const headStyle = {
    width: '100%',
    height: '60px',
  }

  const bodyStyle = {
    padding: '20px',
  }

  const labelStyle = {
    height: '60px',
    background: theme.palette.violetsAreBlue,
    color: 'white',
    fontSize: '20px',
    fontWeight: '500',
    borderRadius: '50px 0px',
    padding: '0px 40px',    
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }

  const descriptionStyle = {
    color: theme.palette.oxfordBlue,
    fontSize: '16px',
    fontWeight: '500',
    paddingBottom: '20px',
  }

  return (
    <Box sx={wrapperStyle}>
      <Stack
        direction='row'
        alignItems='center'
        justifyContent='space-between'
        sx={headStyle}
      >
        <Box sx={labelStyle}>
          <Box>{defaultTexts.paymentMethods}</Box>
        </Box>
        <Box sx={{ paddingRight: '10px ' }}>
          {
            expanded ?
            <IconButton onClick={() => setExpanded(false)}>
              <FaMinimize color={theme.palette.greenSheen} />
            </IconButton> :
            <IconButton onClick={() => setExpanded(true)}>
              <FaMaximize color={theme.palette.greenSheen} />
            </IconButton>
          }
        </Box>
      </Stack>

      {
        expanded &&
        <Box sx={bodyStyle}>
          <Box sx={descriptionStyle}>{defaultTexts.paymentMehotdsSupportingSelectedCurrency}</Box>

          {
            availablePaymentMethods.map((item, index) => (
              <ConfigBillingPaymentMethodsItem
                key={index}
                {...item}
                paymentMethods={paymentMethods}
                setPaymentMethods={setPaymentMethods}
                paymentMethodIds={paymentMethodIds}
                setPaymentMethodIds={setPaymentMethodIds}
              />
            ))
          }          
        </Box>
      }
    </Box>
  )
}

export default ConfigBillingPaymentMethods